import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React, { useRef, useState, useEffect } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { addApplication } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IApplication } from '../../store/siteWebSlice';
import { IReduxState } from '../../store';


interface IAddProps {
  editionApplication: any;
  arrayImageIllustrationToEdit: any;
  setArrayImageIllustrationToEdit: any;
}


const EditImageIllustration = (props: IAddProps) => {

  //props
  const {
    editionApplication,
    arrayImageIllustrationToEdit,
    setArrayImageIllustrationToEdit
  } = props
  // console.log("🚀 ~ file: EditImageIllustration.tsx:35 ~ EditImageIllustration ~ arrayImageIllustrationToEdit:", arrayImageIllustrationToEdit)


  //redux
  const { filteredApplications } = useSelector((state: IReduxState) => state.siteWeb);


  //hooks
  const selectImageIllustrationPhoto: any = useRef(null);
  const [loadingSelectImageIllustrationPhoto, setLoadingSelectImageIllustrationPhoto] = React.useState<boolean>(false);


  /**
   * cette fonction permet de charger les images de la galérie
   *  puis transforme le fichier en base 64
   * @param event 
   */

  const handleAddImageIllustrationPhotosBase64 = (event: any) => {
    setLoadingSelectImageIllustrationPhoto(true)
    const fileList = event.target.files;
    const fileObjects: any = Array.from(fileList).map((file: any) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Lit le fichier en tant que DataURL
      // Crée une promesse pour attendre la fin de la lecture du fichier
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve({
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified,
            url: reader.result, // Récupère le résultat en tant que DataURL
          });
        };
      });
    });
    // Attend que toutes les promesses soient résolues
    Promise.all(fileObjects).then((results) => {
      setArrayImageIllustrationToEdit([...arrayImageIllustrationToEdit, ...results]);
      setLoadingSelectImageIllustrationPhoto(false)
    });
  };


  /**
   * Permet de supprimer une image du tableau local.
   * @param currentIndex
   */
  const handlePhotoDelete = (currentIndex: number) => {
    let newData = [...arrayImageIllustrationToEdit]
    const res = newData.filter((item, index) => index !== currentIndex)
    setArrayImageIllustrationToEdit(res)
  };


  /**
 *  cette fonction permet de repositionner les images
 * @param result (draggableId, source, destination)
 * (draggableId:l'identifiant de l'image à deplacer)
 * (source:la position de depart de l'image à deplacer)
 * (destination:la position d'arriver de l'image à deplacer)
 * @returns
 *
 */
  const onDragEnd = (result: any) => {
    const { draggableId, source, destination } = result;
    const parseIntdraggableId = parseInt(draggableId);
    //Ne rien executer si on deplace un item hors de la carde
    if (!destination) {
      return;
    }
    //Ne rien executer si l'on bouge un item et qu'on le remet à sa place
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    //obtenir l'objet à repositionnner
    const sectionARepositionner: any = arrayImageIllustrationToEdit?.find(
      (section: any, index: number) => index === parseIntdraggableId
    );
    //remplacer les places dans le tableau
    let newPhotoImageIllustration = [...arrayImageIllustrationToEdit];
    newPhotoImageIllustration.splice(source.index, 1);
    newPhotoImageIllustration.splice(destination.index, 0, sectionARepositionner);

    //mise à jour du state
    setArrayImageIllustrationToEdit(newPhotoImageIllustration);
    return;
  };

  const getImagesIllustration = () => {
    setLoadingSelectImageIllustrationPhoto(true)
    let images: any = []
    filteredApplications.map((item: IApplication, index: number) => {
      if (item.idApp === editionApplication.idApp) {
        images.push(item)
      }
    })
    Promise.all(images).then((results) => {
      setArrayImageIllustrationToEdit([...arrayImageIllustrationToEdit, ...results])
      setLoadingSelectImageIllustrationPhoto(false)
    });
  }

  useEffect(() => {
    getImagesIllustration()
  }, [editionApplication.idApp])


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid item md={12} xs={12} sm={12}>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >

          <Grid item md={4} xs={12} sm={4}>
            <Tooltip title="Charger les images de la galérie">
              <Button
                variant="outlined"
                color="primary"
                component="label"
                startIcon={<ArtTrackIcon />}
                style={{ marginTop: 10 }}
                onClick={() => {
                  selectImageIllustrationPhoto?.current?.click();
                }}
              >
                Ajouter des images
              </Button>
            </Tooltip>
            <input
              hidden
              multiple
              type="file"
              name="galeriePhoto"
              ref={selectImageIllustrationPhoto}
              onChange={handleAddImageIllustrationPhotosBase64}
            />
          </Grid>

          <Grid item md={8} xs={12} sm={8}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable" direction="vertical">
                {(provider: any) => (
                  <div
                    style={{
                      background: "aliceblue",
                      padding: 10,
                      height: "57vh",
                      overflow: "auto",
                    }}
                    ref={provider.innerRef}
                    {...provider.droppableProps}
                  >
                    <Box sx={{ flexGrow: 1, width: "100%" }}>
                      <List dense={true}>
                        {/* <Grid
                          container
                          spacing={2}
                          direction="row"
                          justifyContent="flex-start"
                        > */}
                        {arrayImageIllustrationToEdit.length > 0 &&
                          arrayImageIllustrationToEdit.map((item: any, i: number) => {
                            const newIndex = i.toString();
                            return (
                              <div key={i}>
                                <Draggable draggableId={newIndex} index={i}>
                                  {(provider: any, snapshot: any) => (
                                    <div
                                      ref={provider.innerRef}
                                      {...provider.draggableProps}
                                      {...provider.dragHandleProps}
                                    >
                                      <ListItem
                                        secondaryAction={
                                          <IconButton
                                            onClick={() =>
                                              handlePhotoDelete(i)
                                            }
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        }
                                      >
                                        <img
                                          src={item.url ? item.url : `${SITEWEB_SERVER_BASE_URL}/appImage/${item?.libAppImage}`}
                                          style={{ width: "10%", height: "10%", borderRadius: "10%" }}
                                        />
                                      </ListItem>
                                      <Divider />
                                      {provider.placeholder}
                                    </div>
                                  )}
                                </Draggable>
                              </div>
                            );
                          })}
                        {loadingSelectImageIllustrationPhoto && "Veuillez patienter svp..."}
                        {/* </Grid> */}
                      </List>
                    </Box>
                    {provider.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EditImageIllustration;